import vars from '../vars';
import keyMirror from './keyMirror';

// buildTypes signify the webpack build config used (NODE_ENV)
const buildType = vars.get('NODE_ENV');
const buildTypes = keyMirror('development', 'production');

// deploymentEnvs signify the deployment environment (TI_ENV)
const deploymentEnv = vars.get('TI_ENV');
const deploymentEnvs = keyMirror(
  'local',
  'pr', // pull request
  'development',
  'qa',
  'stage',
  'itg',
  'production',
);

// build types
export const isDevBuild = () => buildType === buildTypes.development;

// deployment environments
export const isLocalEnv = () => deploymentEnv === deploymentEnvs.local;
export const isPullRequestEnv = () => deploymentEnv === deploymentEnvs.pr;
export const isProdDeploymentEnv = () =>
  deploymentEnv === deploymentEnvs.production;

// build types and deployment environments
export const isProdBuildAndLocalEnv = () => !isDevBuild() && isLocalEnv();

// miscellaneous
export const usesProductionApis = [
  deploymentEnvs.production,
  deploymentEnvs.stage,
  deploymentEnvs.itg,
].includes(deploymentEnv);
